export default "__VITE_ASSET__BeEg0554__"